import type { ActionItem } from './SearchCommand';
export type CommandResult = void | ActionItem[];

export class BaseCommand {
  protected typed: string[];
  protected expectedParts: string[];
  protected parameters: string[];
  protected parameterDescriptions: { key: string; description: string }[];

  constructor() {
    this.typed = [];
    this.expectedParts = this.getKeywords();
    this.parameters = [];
    this.parameterDescriptions = [];
  }

  getKeywords(): string[] {
    return [];
  }

  getTyped(): string {
    return this.typed.join(' ');
  }

  getCommand(): string {
    return this.getKeywords().join(' ');
  }

  add(value: string, isPartial: boolean): void {
    this.typed.push(value);

    if (this.isPartExpected(value, isPartial)) {
      this.expectedParts.shift();
    } else {
      throw new Error(`Invalid command: ${this.typed}`);
    }
  }

  isPartExpected(part: string, isPartial: boolean): boolean {
    if (this.expectedParts.length === 0) {
      return false;
    }
    return this.expectedParts[0] === part || (isPartial && this.expectedParts[0].startsWith(part));
  }

  renderPartialCommand(): string {
    const fullCommand = this.getCommand();
    const partialCmd = this.typed.join(' ');
    const cmd = fullCommand.replace(partialCmd, '');
    return `<span class='cmd_typed has-text-primary'>${partialCmd}</span><span class='cmd'>${cmd}</span>`;
  }

  renderParameters(): string {
    return this.parameterDescriptions
      .map((param, i) => {
        if (!this.parameters[i]) {
          return `<span class='tag is-light'>${param.key}: ${param.description}</span>`;
        }
        return `<span class='tag is-success'>${this.parameters[i]}</span>`;
      })
      .join(' ');
  }

  preview(): string {
    return `${this.renderPartialCommand()} ${this.renderParameters()}`;
  }

  action(
    parameters: string[],
    onMessage?: (message: string) => void,
  ): void | Promise<CommandResult> {
    return;
  }

  navigateToResult(index: number, newTab = false): void {
    // default no-op
  }
}
